export default "__VITE_ASSET__ef7224af__"